import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { PATTERNS_DATA } from '../../utils/bab/bab.utils'

import './pattern-item.styles.scss'

const PatternItem = ({ patternId, productTypeId }) => {
  const { t } = useTranslation('updatedBAB')

  const patternData = PATTERNS_DATA.find((pattern) => pattern.id === patternId)

  return (
    <li className='pattern-item' data-active={patternData ? '' : null}>
      {patternData && (
        <Fragment>
          {productTypeId === 'pants' ? (
            <img
              className='pattern-item-image'
              src={`${patternData.imageSources.pants}?height=55`}
              alt={t(patternData.translationKeys.imageAlt.pants)}
              width='110'
              height='55'
              loading='lazy'
            />
          ) : (
            <img
              className='pattern-item-image'
              src={`${patternData.imageSources.diapers}?height=55`}
              alt={t(patternData.translationKeys.imageAlt.diapers)}
              width='110'
              height='55'
              loading='lazy'
            />
          )}
        </Fragment>
      )}
    </li>
  )
}

export default PatternItem
